import React from 'react';
import classnames from 'classnames';

import styles from './heading.module.scss';

export type HeadingProps = {
  variant:
    | 'headline-functional-50'
    | 'headline-functional-100'
    | 'headline-functional-200'
    | 'headline-functional-300'
    | 'headline-functional-400'
    | 'display-emotional-100'
    | 'display-emotional-200'
    | 'display-emotional-300'
    | 'subheadline-100'
    | 'subheadline-200'
    | 'unstyled'
    // Display Headline
    | 'D-300'
    | 'D-200'
    | 'D-100'
    // UI Headline
    | 'HL-300'
    | 'HL-200'
    | 'HL-100'
    | 'HL-50'
    // Deprecated
    | 'headline-emotional-50'
    | 'headline-emotional-100'
    | 'headline-emotional-200'
    | 'headline-emotional-300'
    | 'headline-emotional-400'
    | 'display-functional-100'
    | 'display-functional-200'
    | 'display-functional-200-fixed'
    | 'display-functional-300';
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span' | 'label' | 'figcaption';
  withShadow?: boolean;
} & Pick<React.HTMLAttributes<HTMLHeadingElement>, 'children' | 'className' | 'id'>;
type HeadingRefTypes = HTMLHeadingElement & HTMLDivElement & HTMLSpanElement & HTMLLabelElement;

const baseClass = 'heading';

export const Heading = React.forwardRef<HeadingRefTypes, HeadingProps>(
  ({ className, id, tag: Component = 'h1', withShadow, children, variant }, ref) => {
    const classes = classnames(
      styles.heading,
      styles[`${baseClass}--${variant}`],
      { [styles[`${baseClass}--${variant}--with-shadow`]]: withShadow },
      className
    );

    return (
      <Component className={classes} id={id} data-testid="heading-component" ref={ref}>
        {children}
      </Component>
    );
  }
);

Heading.displayName = 'Heading';
